/**
 * ELLIZ PDP — product template only (does not affect homepage / quick view)
 */
(function () {
  if (!document.body.classList.contains('template-product')) return;

  var MARQUEE_SPEED_PX = 28;
  var VISIBLE_COLS = 4;
  var DESKTOP_MQ = window.matchMedia('(min-width: 768px)');

  function initMarquee() {
    var section = document.querySelector('body.template-product [data-section-name="main-product"]');
    if (!section) return;

    var marquee = section.querySelector('[data-elliz-marquee]');
    if (!marquee) return;

    var track = marquee.querySelector('.elliz-pdp-marquee__track');
    var pauseBtn = marquee.querySelector('.elliz-pdp-gallery-controls__pause');
    if (!track) return;

    var mediaCount = parseInt(marquee.getAttribute('data-media-count'), 10) || 1;

    function slideWidth(viewportW, visible) {
      var gap = 3;
      return (viewportW - gap * (visible - 1)) / visible;
    }

    function setCloneVisibility(hide) {
      track.querySelectorAll('.elliz-pdp-marquee__item--clone').forEach(function (el) {
        el.classList.toggle('is-clone-hidden', hide);
      });
    }

    function updateSlideSizes() {
      if (!DESKTOP_MQ.matches) return;
      var vw = marquee.offsetWidth || window.innerWidth;
      var visible = marquee.classList.contains('is-static')
        ? Math.max(1, Math.min(mediaCount, VISIBLE_COLS))
        : VISIBLE_COLS;
      var w = slideWidth(vw, visible);
      marquee.style.setProperty('--elliz-slide-width', w + 'px');
      marquee.style.setProperty('--elliz-slide-gap', '3px');
    }

    function applyGalleryMode() {
      if (!DESKTOP_MQ.matches) {
        marquee.classList.remove('is-static');
        track.style.removeProperty('width');
        setCloneVisibility(false); /* 07-14 v3: klonlar GÖRÜNÜR — sonsuz döngü bunlarla */
        return;
      }

      /* Static fill only for 1–3 photos; 4+ always marquee scroll */
      if (mediaCount < VISIBLE_COLS) {
        marquee.classList.add('is-static');
        track.style.width = '100%';
        setCloneVisibility(true);
        if (pauseBtn) {
          var controls = pauseBtn.closest('.elliz-pdp-gallery-controls');
          if (controls) controls.style.display = 'none';
        }
      } else {
        marquee.classList.remove('is-static');
        track.style.removeProperty('width');
        setCloneVisibility(false); /* 07-14 v3: klonlar GÖRÜNÜR — sonsuz döngü bunlarla */
        if (pauseBtn) {
          var ctrl = pauseBtn.closest('.elliz-pdp-gallery-controls');
          if (ctrl) ctrl.style.display = ''; /* 07-14 v3: pause butonu geri — akışı durdurur */
        }
      }

      updateSlideSizes();
    }

    function setDuration() {
      if (marquee.classList.contains('is-static')) {
        track.style.animation = 'none';
        return;
      }
      var halfWidth = track.scrollWidth / 2;
      if (halfWidth <= 0) return;
      var seconds = Math.max(40, halfWidth / MARQUEE_SPEED_PX);
      track.style.setProperty('--elliz-marquee-duration', seconds + 's');
      track.style.animation = '';
    }

    applyGalleryMode();
    setDuration();

    window.addEventListener('resize', function () {
      applyGalleryMode();
      setDuration();
    });

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        if (marquee.classList.contains('is-static')) return;
        var paused = marquee.classList.toggle('is-paused');
        pauseBtn.classList.toggle('is-paused', paused);
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      });
    }

    /* 2026-07-14 GECE v3: OTOMATİK AKIŞ + SONSUZ DÖNGÜ + SÜRÜKLEME bir arada.
       Eski görünüm (Bershka marquee: kendi kendine yavaşça akar, uçsuz döngü) geri
       geldi ama CSS animasyonuyla DEĞİL — native scroll + rAF ile scrollLeft sürülür
       (CSS animasyon inline transform'u eziyordu, cascade savaşı bitti). Klonlar
       görünür (dikişsiz döngü bunlarla), sarmalama klon setinin başında yapılır.
       Sürükleme/trackpad/Shift+tekerlek çalışır; parmak/fare basılıyken ve ΙΙ (pause)
       butonuyla akış durur. 8px üzeri harekette click yutulur (yanlış lightbox açılmaz). */
    (function initMarqueeDrag() {
      if (marquee.__ellizDrag) return; marquee.__ellizDrag = 1;
      if (marquee.classList.contains('is-static')) return;
      var viewport = marquee.querySelector('.elliz-pdp-marquee__viewport') || marquee;
      track.style.animation = 'none';
      track.style.transform = 'none';
      viewport.style.overflowX = 'auto';
      viewport.style.scrollbarWidth = 'none';
      viewport.style.cursor = 'grab';
      viewport.style.userSelect = 'none';
      viewport.style.webkitUserSelect = 'none';
      var startX = 0, startPos = 0, dragging = false, moved = false;
      var pos = 0, lastT = 0;
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function loopW() {
        var items = track.children;
        if (items.length >= mediaCount + 1) {
          var w = items[mediaCount].offsetLeft - items[0].offsetLeft;
          if (w > 0) return w;
        }
        var sw = track.scrollWidth / 2;
        return sw > 0 ? sw : 0;
      }
      function wrapPos() {
        var w = loopW(); if (!w) return;
        while (pos >= w) pos -= w;
        while (pos < 0) pos += w;
      }
      function tick(t) {
        if (lastT) {
          var dt = (t - lastT) / 1000;
          /* dış kaydırma (trackpad/tekerlek) ile senkron kal */
          if (!dragging && Math.abs(viewport.scrollLeft - pos) > 2) pos = viewport.scrollLeft;
          if (!dragging && !reducedMotion && !marquee.classList.contains('is-paused') && dt < 0.4) {
            pos += MARQUEE_SPEED_PX * dt;
            wrapPos();
            viewport.scrollLeft = pos;
          }
        }
        lastT = t;
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      viewport.addEventListener('dragstart', function (e) { e.preventDefault(); }, true);
      viewport.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        dragging = true; moved = false; startX = e.clientX;
        pos = viewport.scrollLeft; startPos = pos;
        viewport.style.cursor = 'grabbing';
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 8) moved = true;
        pos = startPos - dx;
        wrapPos();
        viewport.scrollLeft = pos;
      });
      function endDrag() { if (!dragging) return; dragging = false; viewport.style.cursor = 'grab'; }
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    })();

    if (window.Shopify && Shopify.designMode) {
      marquee.classList.add('is-paused');
    }
  }

  function initMobileGallery() {
    var section = document.querySelector('body.template-product [data-section-name="main-product"]');
    if (!section) return;

    section.querySelectorAll('.product--thumbnail_slider__mobile lightbox-opener').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    /* ELLIZ 07-17 — VIDEOLU URUNDE KAYDIRMA OLUMU FIX'I:
       Slaytin tamamini kaplayan poster BUTONU Chromium'da (Android Chrome dahil)
       pointerdown'da native ODAK aliyor; Swiper, odakli focusableElements
       (button/video listede) uzerindeki tum surukleme hareketlerini YUTUYOR ->
       video slaytinda kaydirma kalici oluyordu.
       (a) pointerdown'da preventDefault = odak hic olusmaz; click yine atesleneir,
       tikla-oynat (loadContent) bozulmaz. */
    section.querySelectorAll('.product--thumbnail_slider__mobile .deferred-media__poster').forEach(function (btn) {
      if (btn._ezNoFocus) return;
      btn._ezNoFocus = true;
      btn.addEventListener('pointerdown', function (e) { e.preventDefault(); });
    });

    /* (b) destek katmani: galeri swiper ORNEGININ focusableElements listesinden
       button/video'yu cikar (instance-basi kopya, global yan etki yok);
       gec init'i slide_inited olayi yakalar. */
    section.querySelectorAll('.product--thumbnail_slider__mobile swiper-slider').forEach(function (slider) {
      function patch() {
        if (slider.swiper && slider.swiper.touchEventsData) {
          slider.swiper.touchEventsData.focusableElements = 'input, select, option, textarea';
        }
      }
      if (!slider._ezFocusPatch) {
        slider._ezFocusPatch = true;
        slider.addEventListener('slide_inited', patch);
      }
      patch();
    });
  }

  function portalSizeGuideDrawer() {
    var drawer = document.querySelector('[data-elliz-sg-drawer]');
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
  }

  function fixFreeShippingBar() {
    document.querySelectorAll('body.template-product free-delivery-bar .fshbar').forEach(function (el) {
      var text = (el.textContent || '').trim();
      if (!text || /€|EUR/i.test(text)) return;
      var after = '';
      if (el.nextSibling && el.nextSibling.nodeType === 3) {
        after = el.nextSibling.textContent || '';
      }
      if (/^\s*€/.test(after)) return;
      if (/\d/.test(text)) {
        el.textContent = text.replace(/\s+$/, '') + '€';
      }
    });
  }

  function watchFreeShippingBar() {
    fixFreeShippingBar();
    document.querySelectorAll('body.template-product free-delivery-bar').forEach(function (bar) {
      if (bar.dataset.ellizFshWatch) return;
      bar.dataset.ellizFshWatch = '1';
      new MutationObserver(fixFreeShippingBar).observe(bar, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  }

  function syncFewPhotosClass() {
    var section = document.querySelector('[data-section-name="main-product"]');
    var isFew = section && section.classList.contains('elliz-pdp-few-photos');
    var isOne = section && section.classList.contains('elliz-pdp-one-photo');
    document.body.classList.toggle('elliz-pdp-few-photos', !!isFew);
    document.documentElement.classList.toggle('elliz-pdp-few-photos', !!isFew);
    document.body.classList.toggle('elliz-pdp-one-photo', !!isOne);
    document.documentElement.classList.toggle('elliz-pdp-one-photo', !!isOne);
  }

  function placeShippingBarAfterCart() {
    var delivery = document.querySelector('body.template-product #product-page-free-delivery');
    var buttons = document.querySelector(
      'body.template-product [data-section-name="main-product"] .product-form__buttons'
    );
    if (!delivery || !buttons || delivery.dataset.ellizPlaced === '1') return;
    if (buttons.nextElementSibling === delivery) {
      delivery.dataset.ellizPlaced = '1';
      return;
    }
    buttons.insertAdjacentElement('afterend', delivery);
    delivery.dataset.ellizPlaced = '1';
    fixFreeShippingBar();
  }

  function placeProductSkuAfterDelivery() {
    var strip = document.querySelector('body.template-product [data-section-name="main-product"] .elliz-pdp-delivery-strip');
    var label = document.querySelector('body.template-product [data-section-name="main-product"] .custom-sku-label');
    var wrapper = document.querySelector('body.template-product [data-section-name="main-product"] .custom-sku-wrapper');
    if (!strip || !label || !wrapper || strip.dataset.ellizSkuPlaced === '1') return;
    if (strip.nextElementSibling === label) {
      strip.dataset.ellizSkuPlaced = '1';
      return;
    }
    strip.insertAdjacentElement('afterend', label);
    label.insertAdjacentElement('afterend', wrapper);
    strip.dataset.ellizSkuPlaced = '1';
  }

  function syncHeaderOffset() {
    var header = document.querySelector('.shopify-section-group-header-group, .section-header');
    if (header && header.offsetHeight) {
      document.body.style.setProperty('--elliz-header-offset', header.offsetHeight + 'px');
    }
  }

  /* ── Content-aware header logo + icon color ──
     Samples the top region of the product gallery images and picks a
     dark or light (white) logo/icons. Stable per product (no flicker).
     Falls back to white-over-gallery if pixels can't be read (CORS). */
  var ellizLogoLum = null;

  function ellizTinySrc(src) {
    if (!src) return null;
    try {
      var u = new URL(src, window.location.href);
      u.searchParams.set('width', '120');
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  function ellizSampleTopLuminance(img) {
    try {
      var nw = img.naturalWidth, nh = img.naturalHeight;
      if (!nw || !nh) return null;
      // Sample the center-top band — the area directly under the centered logo.
      var sx = Math.round(nw * 0.3);
      var sw = Math.max(1, Math.round(nw * 0.4));
      var sh = Math.max(1, Math.round(nh * 0.22));
      var cw = 20, ch = 20;
      var canvas = document.createElement('canvas');
      canvas.width = cw;
      canvas.height = ch;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, sx, 0, sw, sh, 0, 0, cw, ch);
      var data = ctx.getImageData(0, 0, cw, ch).data;
      var sum = 0, n = 0;
      for (var i = 0; i < data.length; i += 4) {
        sum += 0.2126 * (data[i] / 255) + 0.7152 * (data[i + 1] / 255) + 0.0722 * (data[i + 2] / 255);
        n++;
      }
      return n ? sum / n : null;
    } catch (e) {
      return null;
    }
  }

  function ellizApplyLogo() {
    if (!document.body.classList.contains('template-product')) return;
    var solid = document.body.classList.contains('elliz-header-solid');
    var dark;
    if (solid) {
      dark = true;
    } else if (ellizLogoLum == null) {
      dark = window.matchMedia('(min-width: 768px)').matches;
    } else {
      dark = ellizLogoLum >= 0.55;
    }
    document.body.classList.toggle('elliz-logo-dark', dark);
    document.body.classList.toggle('elliz-logo-light', !dark);
  }

  function ellizComputeLogo() {
    if (!document.body.classList.contains('template-product')) return;
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    var selector = isMobile
      ? 'body.template-product [data-section-name="main-product"] .product--thumbnail_slider__mobile .product__media img'
      : 'body.template-product [data-section-name="main-product"] .product--thumbnail_slider:not(.product--thumbnail_slider__mobile) .product__media img';
    var srcs = [];
    document.querySelectorAll(selector).forEach(function (img) {
      var s = img.currentSrc || img.getAttribute('src');
      if (s) srcs.push(s);
    });
    srcs = srcs.slice(0, 3);
    if (!srcs.length) { ellizApplyLogo(); return; }

    var results = [], pending = srcs.length;
    function done() {
      ellizLogoLum = results.length
        ? results.reduce(function (a, b) { return a + b; }, 0) / results.length
        : null;
      ellizApplyLogo();
    }
    srcs.forEach(function (src) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        var l = ellizSampleTopLuminance(im);
        if (l != null) results.push(l);
        if (--pending === 0) done();
      };
      im.onerror = function () {
        if (--pending === 0) done();
      };
      im.src = ellizTinySrc(src);
    });
  }

  function initMobileTransparentHeader() {
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    var isFewDesktop = !isMobile && document.querySelector('[data-section-name="main-product"].elliz-pdp-few-photos');

    if (isFewDesktop) {
      document.body.classList.add('elliz-header-solid');
      ellizApplyLogo();
      return;
    }

    var threshold = isMobile ? 20 : 16;
    function onScroll() {
      document.body.classList.toggle('elliz-header-solid', window.scrollY > threshold);
      ellizApplyLogo();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function fixMobilePagination() {
    if (window.matchMedia('(min-width: 768px)').matches) return;

    document.querySelectorAll('body.template-product .product--thumbnail_slider__mobile .swiper-control-container .swiper-pagination').forEach(function (pag) {
      var bullets = pag.querySelectorAll('.swiper-pagination-bullet');
      var seen = {};
      bullets.forEach(function (bullet, index) {
        var key = bullet.getAttribute('aria-label') || String(index);
        if (seen[key]) {
          bullet.remove();
        } else {
          seen[key] = true;
        }
      });
    });
  }

  function getMediaCount() {
    var section = document.querySelector('body.template-product [data-section-name="main-product"]');
    if (!section) return 99;
    return parseInt(section.getAttribute('data-elliz-media-count'), 10) || 99;
  }

  function ensureMobileGalleryImages() {
    if (window.matchMedia('(min-width: 768px)').matches) return;
    var section = document.querySelector('body.template-product [data-section-name="main-product"]');
    if (!section) return;

    section.querySelectorAll('.product--thumbnail_slider__mobile .swiper-slide img').forEach(function (img, index) {
      if (index === 0) {
        img.loading = 'eager';
        img.removeAttribute('loading');
      }
      img.style.display = 'block';
    });
  }

  function fixMobileGalleryScroll() {
    if (window.matchMedia('(min-width: 768px)').matches) return;

    var section = document.querySelector('body.template-product [data-section-name="main-product"]');
    if (!section) return;

    section.querySelectorAll('.product--thumbnail_slider__mobile swiper-slider').forEach(function (slider) {
      slider.removeAttribute('data-autoheight');
      if (slider.swiper) {
        slider.swiper.params.autoHeight = false;
        slider.swiper.update();
      }
    });

    [400, 1200].forEach(function (ms) {
      setTimeout(fixMobilePagination, ms);
    });

    section.querySelectorAll('.product--thumbnail_slider__mobile swiper-slider-container, .product--thumbnail_slider__mobile .swiper').forEach(function (el) {
      el.style.overflow = '';
      el.style.maxHeight = '';
      el.style.touchAction = 'pan-y';
    });
  }

  function fixPageScroll() {
    document.documentElement.style.overflowX = 'clip';
    document.body.style.overflowX = 'clip';
    var main = document.getElementById('MainContent');
    if (main) {
      main.style.overflow = 'visible';
    }
  }

  function initDualRecSwipers() {
    document.querySelectorAll('body.template-product [data-section-name="elliz-dual-recommendations"] swiper-slider.elliz-dual-rec__swiper').forEach(function (slider) {
      if (typeof Swiper === 'function' && typeof slider.start === 'function' && !slider.swiper) {
        try { slider.start(); } catch (e) { /* wait for script */ }
      }

      if (!slider.swiper) return;

      slider.classList.add('swiper-initialized-custom');
      var delay = Number(slider.getAttribute('data-autoplay-delay')) || 4000;

      if (slider.classList.contains('elliz-dual-rec__swiper--autoplay')) {
        slider.swiper.params.autoplay = {
          delay: delay,
          pauseOnMouseEnter: false,
          disableOnInteraction: false
        };
        if (slider.swiper.autoplay) {
          slider.swiper.autoplay.start();
        }
      }
    });
  }

  function scheduleDualRecInit() {
    [0, 200, 600, 1200, 2500].forEach(function (ms) {
      setTimeout(function () {
        /* ELLIZ 07-17: buradaki SAHTE swiperLoaded dispatch'i SILINDI — Swiper
           yuklu degilken yayinlamak sayfadaki tum swiper-slider'lari erken
           start() edip 'this.swiper.on is not a function' hatasi (x3) atiyordu.
           Gercek olayi temanin kendi loader'i yayinliyor (global.js script.onload). */
        initDualRecSwipers();
      }, ms);
    });
  }

  function watchDualRecSection() {
    var root = document.querySelector('body.template-product .elliz-dual-rec-root');
    if (!root || root.dataset.ellizRecWatch) return;
    root.dataset.ellizRecWatch = '1';
    new MutationObserver(function () {
      scheduleDualRecInit();
    }).observe(root, { childList: true, subtree: true });
    scheduleDualRecInit();
  }

  function initBelowFold() {
    var section = document.querySelector('body.template-product [data-section-name="main-product"]');
    var below = section && section.querySelector('[data-elliz-pdp-below]');
    var column = section && section.querySelector('.product__column__content');
    if (!section || !below || !column) return;

    var moved = [];
    var anchor = column.querySelector('.product-form__buttons, .product__buttons, #product-container');

    function restoreAll() {
      moved.slice().sort(function (a, b) { return b.order - a.order; }).forEach(function (item) {
        var el = item.el;
        if (!el.parentElement) return;
        if (item.next && item.next.parentElement === column) {
          column.insertBefore(el, item.next);
        } else if (anchor) {
          anchor.insertAdjacentElement('afterend', el);
        } else {
          column.appendChild(el);
        }
      });
      moved.length = 0;
      below.hidden = true;
    }

    function applyLayout() {
      if (!DESKTOP_MQ.matches || getMediaCount() <= 2) {
        restoreAll();
        return;
      }

      if (moved.length) return;

      below.hidden = false;

      var selectors = [
        '.product-tab:not(.product-tab-secondary)',
        '.product-tab-secondary'
      ];

      selectors.forEach(function (sel) {
        column.querySelectorAll(sel).forEach(function (el) {
          moved.push({ el: el, next: el.nextElementSibling, order: moved.length });
          below.appendChild(el);
        });
      });

      fixFreeShippingBar();
    }

    applyLayout();
    DESKTOP_MQ.addEventListener('change', function () {
      restoreAll();
      applyLayout();
      fixMobileGalleryScroll();
    });
  }

  function boot() {
    fixPageScroll();
    syncFewPhotosClass();
    syncHeaderOffset();
    initMobileTransparentHeader();
    ellizComputeLogo();
    portalSizeGuideDrawer();
    initMarquee();
    initMobileGallery();
    placeShippingBarAfterCart();
    placeProductSkuAfterDelivery();
    initBelowFold();
    watchFreeShippingBar();
    fixMobileGalleryScroll();
    ensureMobileGalleryImages();
    fixMobilePagination();
    watchDualRecSection();
  }

  window.addEventListener('resize', function () {
    syncFewPhotosClass();
    syncHeaderOffset();
    initMobileTransparentHeader();
    ellizComputeLogo();
    fixMobileGalleryScroll();
    ensureMobileGalleryImages();
    fixMobilePagination();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', function () {
    if (!document.body.classList.contains('template-product')) return;
    fixPageScroll();
    syncFewPhotosClass();
    syncHeaderOffset();
    ellizComputeLogo();
    portalSizeGuideDrawer();
    placeShippingBarAfterCart();
    placeProductSkuAfterDelivery();
    initBelowFold();
    watchFreeShippingBar();
    fixMobileGalleryScroll();
    ensureMobileGalleryImages();
    fixMobilePagination();
    scheduleDualRecInit();

    var track = document.querySelector('body.template-product [data-elliz-marquee] .elliz-pdp-marquee__track');
    var marquee = document.querySelector('body.template-product [data-elliz-marquee]');
    if (track && marquee && !marquee.classList.contains('is-static')) {
      var halfWidth = track.scrollWidth / 2;
      var seconds = Math.max(40, halfWidth / MARQUEE_SPEED_PX);
      track.style.setProperty('--elliz-marquee-duration', seconds + 's');
    }
  });
})();
